export default __webpack_public_path__ + "static/media/bg-masthead-2.a8507b85.jpg";